import { Descriptions, type DescriptionsProps } from 'antd';
import styled, { css } from 'styled-components';

interface StyledDescriptionsProps extends DescriptionsProps {
  // TODO: duplication of DescriptionsProps['bordered']
  isBordered?: boolean;
  isEditing?: boolean;
  labelWidth?: number;
}

export const UneditableDescription = styled.div`
  padding-right: 12px;
`;

export const StyledDescriptions = styled(Descriptions)<StyledDescriptionsProps>`
  &&&&&& {
    ${({ isBordered, isEditing, labelWidth }) =>
      !isBordered &&
      css`
        background-color: transparent;

        .ant-descriptions-view,
        .ant-descriptions-row {
          border: none;
        }
        .ant-descriptions-item-label,
        .ant-descriptions-item-content {
          padding: 10px;
          font-size: 14px;
        }

        .ant-descriptions-item-content {
          padding-left: 12px;
        }

        ${
          isEditing &&
          css`
          .ant-descriptions-item-content {
            padding: 5px 0;
          }

          ${UneditableDescription} {
            padding: 5px 12px;
          }
        `
        }

        .ant-descriptions-item-label {
          background-color: transparent;
          border: none;
          width: ${labelWidth ? `${labelWidth}px` : '35%'};
          .ant-form-item-label {
            text-align: left;
            white-space: normal;
            label {
              width: auto;
              word-break: normal;
              height: auto;
              margin-bottom: 0;
            }
          }

          ${
            !labelWidth &&
            css`
            .ant-descriptions-item-content {
              width: 65%;
            }
          `
          }

          .ant-descriptions-item-content {
            background-color: transparent;
            border: none;
          }
        }
      `}

    .ant-descriptions-view > table {
      table-layout: fixed;
    }

    .ant-descriptions-item-label {
      font-weight: 500;
    }
  }
`;
